<template>
  <div class="min-h-screen bg-primary-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md text-center">
      <!-- OXO Logo placeholder or Text -->
      <h2 class="mt-6 text-center text-3xl font-display font-extrabold text-primary-900">
        <span class="text-oxo-red">OXO</span> BackOffice
      </h2>
      <p class="mt-2 text-center text-sm text-primary-600">
        Administration sécurisée
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow-sm sm:rounded-lg sm:px-10 border-t-4 border-oxo-red">
        <slot />
      </div>
    </div>
  </div>
</template>
